<template>
  <button @click="exportTransaction" class="btn btn-outline-gray btn-sm is-border-1 mr-1">
    <i class="fa fa-download"></i>
    {{ $t('export') }}
    <b-modal v-model="exporting" :title="$t('exportingData')" @close="close" no-close-on-esc no-close-on-backdrop no-enforce-focus>
      <div class="alert alert-warning">
        <span>{{ $t('exportNotice') }}</span>
      </div>
      <b-progress :max="totalCount">
        <b-progress-bar :value="downloadedCount" :label="`${((downloadedCount / totalCount) * 100).toFixed(0)}%`"></b-progress-bar>
      </b-progress>
    </b-modal>
  </button>
</template>


<script>
import {saveAs} from 'file-saver';
import Excel from 'exceljs';
import moment from 'moment';

export default {
  name: "CallHistoryExport",
  props: ['filter', 'totalCount'],
  data() {
    return {
      exporting: false,
      cancelRequest: false,
      downloadedCount: 0
    }
  },
  methods: {
    exportTransaction: async function () {
      this.downloadedCount = 0;
      this.exporting = true;
      let workbook = new Excel.Workbook();
      let sheet = workbook.addWorksheet('data');
      this.setupSheet(sheet);

      let response = null;
      let params = Object.assign({}, this.filter);
      params.page = 1;
      params.pageSize = 500;
      do {
        if (this.cancelRequest) {
          break;
        }
        let result = await this.$service.get('/call/', {
          params: params
        });
        params.page += 1;
        response = result.data;
        response.docs.forEach(item => {
            let row = {
                    fromUser: item.fromUser && item.fromUser.name ? item.fromUser.name : '',
                    toUser: item.toUser && item.toUser.name ? item.toUser.name : '',
                    toContact: item.toContact && item.toContact.name ? item.toContact.name : '',
                    fromExt: item.fromExt ? item.fromExt : '',
                    toExt: item.toExt ? item.toExt : '',
                    fromNumber: item.fromNumber,
                    toNumber: item.toNumber,
                    startTime: moment(item.startTime).format('DD/MM/YYYY HH:mm:ss'),
                    endTime: moment(item.endTime).format('DD/MM/YYYY HH:mm:ss'),
                    duration: item.duration,
                    billDuration: item.billDuration,
                    direction: this.$t(item.direction),
                    hangupCause: this.$t(item.hangupCause)
                }
          sheet.addRow(row);
          this.downloadedCount += 1;
        });
      } while (response && response.hasNextPage);

      workbook.xlsx.writeBuffer({base64: true}).then(data => {
        this.exporting = false;
        saveAs(new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}),
            'call-history.xlsx');
      }).finally(() => {
        this.cancelRequest = false;
        this.downloadedCount = 0;
      });
    },
    setupSheet: function (sheet) {
      sheet.columns = [
        {header: this.$t('callFromUser'), key: 'fromUser', width: 15},
        {header: this.$t('assignToUserWhoCall'), key: 'toUser', width: 15},
        {header: this.$t('callToUser'), key: 'toContact', width: 15},
        {header: this.$t('fromExt'), key: 'fromExt', width: 15},
        {header: this.$t('toExt'), key: 'toExt', width: 15},
        {header: this.$t('fromNumber'), key: 'fromNumber', width: 15},
        {header: this.$t('toNumber'), key: 'toNumber', width: 15},
        {header: this.$t('startTime'), key: 'startTime', width: 15},
        {header: this.$t('endTime'), key: 'endTime', width: 15},
        {header: this.$t('duration'), key: 'duration', width: 15},
        {header: this.$t('billDuration'), key: 'billDuration', width: 15},
        {header: this.$t('direction'), key: 'direction', width: 15},
        {header: this.$t('hangupCause'), key: 'hangupCause', width: 15},
      ];
    },
    close() {
      this.cancelRequest = true;
    }
  },

}
</script>